import React from 'react';
import SiteUnderConstruction from '../../components/SiteUnderConstruction';

const Home: React.FC = () => <SiteUnderConstruction />;

export default Home;
